import { motion } from "framer-motion";
import { useLang } from "@/lib/lang";
import { CONTACT } from "@/content";
import { ease } from "./motion";

const WA_PATH = "M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.21 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2-1.42.25-.69.25-1.29.18-1.41-.08-.13-.28-.2-.57-.35m-5.42 7.4h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.88 9.88m8.41-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89a11.82 11.82 0 0 0-3.48-8.41Z";

export const WhatsAppButton = () => {
  const { t } = useLang();
  const href = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(t.whatsapp.message)}`;
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp.label}
      data-testid="whatsapp-float-btn"
      initial={{ opacity: 0, y: 30, scale: 0.8 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.9, ease, delay: 2 }}
      className="group fixed bottom-5 end-5 md:bottom-8 md:end-8 z-40 flex items-center gap-3 rounded-full bg-[#25D366] p-3.5 text-white shadow-[0_18px_40px_-12px_rgba(18,140,126,0.65)] transition-[padding,transform] duration-500 hover:-translate-y-0.5 md:hover:pe-6"
    >
      <span className="absolute inset-0 rounded-full border-2 border-[#25D366]/60 animate-ping-slow group-hover:hidden" aria-hidden="true" />
      <svg viewBox="0 0 24 24" className="relative h-7 w-7 shrink-0" fill="currentColor" aria-hidden="true"><path d={WA_PATH} /></svg>
      <span className="relative hidden md:block max-w-0 overflow-hidden whitespace-nowrap text-sm font-medium opacity-0 transition-[max-width,opacity] duration-500 group-hover:max-w-[240px] group-hover:opacity-100">
        {t.whatsapp.label}
      </span>
    </motion.a>
  );
};
